<template>
  <v-container class="widget-screen">
    <dash-header
      :date-range="$store.state.Dashboard.dateRange"
      theme-header="Fulfillment"
      :views="viewTypes"
      :current-theme="currentTheme"
      v-on:date-range-changed="triggerUpdates"
      v-on:range-config-updated="triggerUpdates"
      v-on:theme-changed="handleThemeChange"
      :bus="bus"
      class="widget-header-container"
    ></dash-header>

    <v-layout>
      <v-flex xs9 class="widgetPaddingLeft">
        <excel-download-button view="fulfillment"></excel-download-button>
        <v-tabs
          v-model="active"
          dark
          slider-color="yellow"
          icons-and-text
          class="widgetTabs"
        >
          <v-tab
            key="count"
            ripple
            @click="tabClicked"
          >
            <!--<h3 style="clear: both">Fulfillment by Count</h3>
            <h1>{{ totalCount }}</h1>-->
            <table>
              <tr>
                <td colspan="2"><p class="tabTitle"><strong>Fulfillment by Count</strong></p></td>
              </tr>
              <tr>
                <td colspan="2"><h2>{{ totalCount }}</h2></td>
              </tr>
              <tr >
                <td class="totalCountConverted" style="color: blue !important;">{{ totalCountConverted }} <i class="material-icons">check_circle</i></td>
                <td class="totalCountUnconverted" style="color: red !important;">{{ totalCountUnconverted }} <i class="material-icons">cancel</i></td>
              </tr>
            </table>
          </v-tab>
          <v-tab
            key="value"
            ripple
            @click="tabClicked"
          >
            <!--<h3>Fulfillment by Value</h3>
            <h1>R{{ totalValue }}</h1>-->
            <table>
              <tr>
                <td colspan="2"><p class="tabTitle"><strong>Fulfillment by Value</strong></p></td>
              </tr>
              <tr>
                <td colspan="2"><h2>R{{ totalValue }}</h2></td>
              </tr>
              <tr>
                <td class="totalValueConverted" style="color: blue !important;">R{{ totalValueConverted }} <i class="material-icons">check_circle</i></td>
                <td class="totalValueUnconverted" style="color: red !important;">R{{ totalValueUnconverted }} <i class="material-icons">cancel</i></td>
              </tr>
            </table>
          </v-tab>
          <v-tab-item
            key="count"
            lazy
          >
            <v-card class="justify-center align-center" style="text-align: center">
              <fulfillment-count
                :view-data="dataView.count"
                :date-range="$route.params.dateRange"
                :updateData="updateComponents"
                v-on:widgets-updated="resetTrigger"
                v-on:fulfillment-bar-selected="updateViewByBarSelection"
                :bus="bus"
                v-if="!loading"
              ></Fulfillment-count>
              <img class="imgLoader" src="../../../shared/assets/images/3dloader.gif" v-else   />
            </v-card>
          </v-tab-item>
          <v-tab-item
            key="value"
            lazy
          >
            <v-card class="justify-center align-center" style="text-align: center">
              <fulfillment-value :view-data="dataView.value" :date-range="$route.params.dateRange" :updateData="updateComponents" :bus="bus" v-if="!loading"></Fulfillment-value>
              <img class="imgLoader" src="../../../shared/assets/images/3dloader.gif" v-else   />
            </v-card>
          </v-tab-item>
        </v-tabs>
        <div style="position: relative; top: -40px; z-index: 9999; text-align: center;" v-if="this.$store.state.Dashboard.widgetConfig.viewType === 'date_range' && this.loading === false"><small>Based on Quote Origination date</small></div>
      </v-flex>
      <v-flex xs3 class="widgetPaddingRight">
        <filters v-on:apply-filters="setFilters" :filters="filters" :bus="bus" theme="fulfillment"></filters>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import DashHeader from "../../elements/DashHeader";
import FulfillmentCount from "./widgets/FulfillmentCount";
import FulfillmentValue from "./widgets/FulfillmentValue";
import FulfillmentPercentage from "./widgets/FulfillmentPercentage";
import Vue from "vue";
import moment from "moment";
import Filters from "../../elements/Filters";
import ExcelDownloadButton from "../../elements/ExcelDownloadButton";
import qs from "qs";
export default {
  name: "FulfillmentSection",
  data() {
    return {
      abortController: null,
      viewTypes: {
        label: 'By Date',
        action: () => {
          this.$emit('collate-by-date');
        }
      },
      loading: false,
      items: ['Item 1', 'Item 2', 'Item 3', 'Item 4', 'Item 5'],
      filters: [],
      active: null,
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      updateComponents: false,
      tabTotals: {
        total: 0,
        value: 0,
        nett_total: 0,
        nett_value: 0
      },
      dataView: {
        count: [],
        value: [],
        percent: []
      },
      bus: new Vue(),
      currentTheme: 'conversion'
    }
  },
  methods: {
    fetchData() {
      if (this.abortController)
        this.abortController.abort('The previous request was interrupted.');
      this.$store.commit('setTheme', 'fulfillment');
      console.log('Fetching Fulfillment data');

      this.loading = true;
      this.abortController = new AbortController;
      return this.$axios.get(window.location.protocol + process.env.API_ENDPOINT + 'Widget.php', {
        signal: this.abortController.signal,
        params: {
          a: 'fulfillment',
          token: 'dlBWlbFDgR5A0eearsSZBouOH9I9282I',
          params: {
            manufacturer: this.$store.getters.objAuthorize.manufacturer,
            date_from: this.$store.state.Dashboard.widgetConfig.dateRange.from.length !== 0 ? this.$store.state.Dashboard.widgetConfig.dateRange.from : moment().subtract(3, 'months').format('YYYY-MM-DD'), //this.dateRange.from,
            date_to: this.$store.state.Dashboard.widgetConfig.dateRange.to.length !== 0 ? this.$store.state.Dashboard.widgetConfig.dateRange.to : moment().endOf('day').format('YYYY-MM-DD'), //this.dateRange.to,
            metric: 'count',
            view: this.$store.state.Dashboard.widgetConfig.viewType,
            reporting_interval: this.$store.state.Dashboard.widgetConfig.intervalType,
            filters: this.$store.state.Dashboard.widgetConfig.filters
          }
        },
        paramsSerializer: params => {
          return qs.stringify(params);
        }
      }).then((response) => {
        this.loading = false;
        const recordSet = response.data;
        this.dataView = recordSet.data;
        this.tabTotals = recordSet.totals;
        this.filters = recordSet.filters;
      }).catch((err) => {
        this.loading = false;
        console.log('An error occurred: ' + err.toString(), err);
      }).finally(() => {
        this.loading = false;
        this.abortController = null;
      });
    },
    triggerUpdates() {
      this.fetchData();
    },
    resetTrigger() {
      this.updateComponents = false;
    },
    nFormatter(num, digits) {
      const lookup = [
        { value: 1, symbol: "" },
        { value: 1e3, symbol: "k" },
        { value: 1e6, symbol: "m" },
        { value: 1e9, symbol: "b" },
        { value: 1e12, symbol: "t" },
        { value: 1e15, symbol: "p" },
        { value: 1e18, symbol: "e" }
      ];
      const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
      const item = lookup.slice().reverse().find(function(item) {
        return num >= item.value;
      });
      return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
    },
    setFilters(event) {
      console.log('Filters Applied in Conversions', event);
      this.triggerUpdates();
    },
    updateViewByBarSelection(event) {
      this.bus.$emit('trigger-view-update', event);
    },
    handleThemeChange(event) {
      this.bus.$emit('theme-changed', event);
    },
    tabClicked() {
      this.bus.$emit('tab-changed');
    }
  },
  components: {ExcelDownloadButton, Filters, FulfillmentPercentage, FulfillmentValue, FulfillmentCount, DashHeader},
  computed: {
    /*
    nett_total: 2164
nett_value: 4628608.23
total: 4304
value: 0
     */
    totalCount: function() {
      const val = parseInt(this.tabTotals.total);
      return this.nFormatter(val, 1);
    },
    totalCountConverted: function() {
      const total = parseInt(this.tabTotals.total);
      const sales = parseInt(this.tabTotals.nett_total);
      const val = total - sales;
      return this.nFormatter(val, 1);
    },
    totalCountUnconverted: function() {
      const val = parseInt(this.tabTotals.nett_total);
      return this.nFormatter(val, 1);
    },
    totalValue: function() {
      const val = parseInt(this.tabTotals.value);
      return this.nFormatter(val, 1);
    },
    totalValueConverted: function() {
      const total = parseInt(this.tabTotals.value);
      const sales = parseInt(this.tabTotals.nett_value);
      const val = total - sales;
      return this.nFormatter(val, 1);
    },
    totalValueUnconverted: function() {
      const val = parseInt(this.tabTotals.nett_value);
      return this.nFormatter(val, 1);
    },
    totalPercent: function() {
      const nett = parseInt(this.tabTotals.nett_total);
      const gross = parseInt(this.tabTotals.total);
      return ((nett / gross) * 100).toFixed(0) + '%';
    }
  },
  created() {
    this.loading = true;
    this.$store.state.Dashboard.widgetConfig.theme = 'fulfillment';

    this.fetchData();

    this.bus.$on('trigger-theme-changed', () => {
      if (this.abortController)
        this.abortController.abort();
    });
  }
}
</script>

<style scoped>

</style>
